import {mapState} from 'vuex';
import moment from 'moment';
import Vue from 'vue';
import {Tabs, Tab} from 'kpc/components/tabs';
import Table, {TableColumn} from 'kpc/components/table';
import {Pagination} from 'kpc/components/pagination';
import Button, {ButtonGroup} from 'kpc/components/button';
import Tooltip from 'kpc/components/tooltip';
import Dialog from 'kpc/components/dialog';
import Input from 'kpc/components/input';
import Radio from 'kpc/components/radio';
import {Select, Option} from 'kpc/components/select';
import * as step1Const from '../../../store/create/step1/constants';
import * as commonConst from '../../../store/common/constants';
import Message from 'kpc/components/message';

export default ({
    name: 'copyimageDia',
    components: {
        Table,
        TableColumn,
        Pagination,
        Button,
        ButtonGroup,
        Tooltip,
        Dialog,
        Input,
        Radio,
        Select,
        Option,
        Tabs,
        Tab,
        Message,
    },
    data() {
        return {  
            cloudmarketShow: false,
            tab:0,
            pages: {
                current: 1,
                totalRows: 0,
                rowsPerPage: 10,
            },
            securityImage:[],
            kecinfo:{},
            userCurrency: '', //用户使用货币的方式
            tablist:[{
                "id": 8572,
                "code": "2001", 
                "parentCode": "1002", 
                "name": "运行环境", 
                "enName": "运行环境", 
                "securityDeposit": 0, 
                "grade": 2,
                "state": 1,
                "url": ""
            }],
            kecType: '',
            quotaMaxDisk: 0,
            systemDiskMax: 0,
            sysDiskObj: {},
        }
    },
    props:{
        imageObjsss: {
            type: Object,
            default: () => {
                return {
                    productName:''
                }
            },
        },
    },
    watch: {
        tab(val, newval){
            if(val != newval){
                this.pages.current = 1,
                this.getMarketImage()
            }
            
        },
        pages(val, old) {
            val.current != old.current ? this.getMarketImage() : undefined;
            val.rowsPerPage != old.rowsPerPage ? (this.pages.current = 1, this.getMarketImage()) : undefined;
        },
    },
    computed: {
        
    },
    created() {
        //获取用户使用货币的方式
        if (window.__ksStorage__) {
            __ksStorage__.getBaseInfo('userInfo', info => {
                this.userCurrency = _.get(info, 'user.currency.symbol', '￥');
            });
        }

    },
    methods: {
        handle(kectype, data, regionKey, quotaMaxDisk, systemDiskMax, sysDiskObj) {
            this.kecPagetype = kectype
            this.regionKey = regionKey;
            this.kecinfo = data;
            this.kecType = data.mock ? data.mock.kecType : data.kecType;
            this.quotaMaxDisk = quotaMaxDisk || 0;
            this.systemDiskMax = systemDiskMax || 0;
            this.sysDiskObj = sysDiskObj || {};
            let promise = $.Deferred();
            // getMarketImage
            promise = $.when(this._getTablist())
            promise.then(()=>{
                this.cloudmarketShow = true    
            })
        },
        close() {
            this.cloudmarketShow = false;
            
       },
       ok() {
            
        },
        changeTab(){

        },
        _getTablist(){
            this.$store.dispatch(step1Const.describeMarketTAbList,{
                params: {
                    Region:this.regionKey,
                },
            }).then((res)=>{
                this.tablist = res.data;
                this.tab = this.tablist[0].code;
                this.getMarketImage()
            }).catch(()=>{

            })
        },
        thorwErrorMessage: _.debounce(function (info) {
            Message.error(info);
        }, 100),
        getMarketImage(){
            let me = this;
            return this.$store.dispatch(step1Const.describeMarketImage, {
                params: {
                    Region:me.regionKey,//后端对镜像市场接口未做修改Region，regionCode都必须传，否则控制台无法校验
                    regionCode:me.regionKey,
                    marketCategory: me.tab,
                    pageNo:me.pages.current,
                    pageSize:me.pages.rowsPerPage   
                },
                options: {
                    isJSON: true
                },
            }).then((res) => {
                let copys = [];
                let products = _.get(res, 'data.items', []);
                let i4ebsOrOther = this.kecType == 357 ? _.get(this.sysDiskObj, 'value', '') != 'Local_SSD' : true;
                //镜像那边人觉得报错提示不好，强烈要求去掉
                // if (!products.length) {
                //     this.thorwErrorMessage(Vue.$trans(`获取镜像列表失败`));
                // }  
                if (this.kecPagetype == "kec" && products.length) {
                    _.forEach(products, (item) => {
                        let isSA1Host = false;
                        let platform = _.get(item, 'osVersion', '');
                        let isWindows = /win.*/i.test(platform.toLowerCase());
                        let isWin2008 = /win.*2008/i.test(platform.toLowerCase());
                        let maxSize = isWindows ? (isWin2008 ? 40 : 50) : 20; //isWindows ? (isWin2008 ? 40 : 50) : 20;
                        let minDisk = _.get(item, 'imageDetail.minDisk', '');
                        item.disabled = false; //默认当前选项是可以选择
                        item.tipInfo = ''; //默认提示内容

                        if (commonConst.isCommonModelType(this.kecType) && this.kecType != 40 && i4ebsOrOther) {
                            if (minDisk > this.systemDiskMax) {
                                item.disabled = true; //禁止当前选项
                                item.tipInfo = '500';
                            }
                            if (this.kecType == 198) { //标准型SA1
                                if (/centos/.test(platform.toLowerCase())) {
                                    //只支持Centos 7.2以上
                                    isSA1Host = platform.split('-')[1] >= 7.2;
                                } else if (/win.*/.test(platform.toLowerCase())) {
                                    //只支持Windows 2016/2012/2019
                                    isSA1Host = /win.*2012/.test(platform.toLowerCase()) || /win.*2016/.test(platform.toLowerCase()) || /win.*2019/.test(platform.toLowerCase());
                                } else if (/ubuntu/.test(platform.toLowerCase())) {
                                    //只支持Ubuntu 16.04/18.04
                                    isSA1Host = platform.split('-')[1] == 16.04 || platform.split('-')[1] == 18.04;
                                }
                                if (isSA1Host) {
                                    item.disabled = false;
                                } else {
                                    item.disabled = true;
                                }
                            }
                        } else {
                            //镜像系统盘大于默认系统盘（20、40、50）就走这个逻辑, 可变系统盘需要单独处理逻辑
                            if (minDisk > maxSize) {
                                if (commonConst.isAdjustSysDiskType(this.kecType) && i4ebsOrOther) { // 可变系统盘机型 
                                    if (minDisk > this.systemDiskMax) {
                                        item.disabled = true;
                                        item.tipInfo = '500';
                                    }
                                } else {
                                    if (minDisk > this.quotaMaxDisk) { //不可变系统盘由quota决定
                                        item.disabled = true; //禁止当前选项
                                        item.tipInfo = '500';
                                    }
                                    if (this.kecType == 357) { //IO优化型I4
                                        if (item.SysDisk > 50) {
                                            item.disabled = true;
                                            item.tipInfo = '100';
                                        }
                                    }
                                }
                            }
                        }
                        
                        copys.push(item);
                    });
                    this.securityImage = _.cloneDeep(copys);  
                }else{
                    this.securityImage = _.cloneDeep(products);
                }
                this.pages.totalRows = res.data.total;
            }).catch(e => {
                
            });
        },
        selectimage(item){
            this.$emit('setImageMarket', item);
            this.cloudmarketShow = false;
        },
        _changePages(type, c, v) {
            this.pages = {
                ...this.pages,
                [type]: v
            };
        },
        go2market(data){
            window.open("//market.ksyun.com/#/detail?id="+ data.productId)
        }
        
    },
    
});
